import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const VerticalPointsIcon = ({ size, color, marginRight, marginLeft, transition, transform, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 8 28"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight, marginLeft, transition, transform }}
    {...props}
  >
    <path
      d="M7.11199 3.315C7.11212 3.72381 7.03173 4.12864 6.87541 4.50637C6.71908 4.88411 6.48989 5.22736 6.20092 5.51652C5.91194 5.80568 5.56884 6.03509 5.1912 6.19166C4.81357 6.34822 4.40879 6.42887 3.99999 6.429C3.59118 6.42913 3.18635 6.34874 2.80862 6.19242C2.43088 6.0361 2.08763 5.80691 1.79847 5.51793C1.50931 5.22896 1.2799 4.88586 1.12333 4.50822C0.966769 4.13058 0.886118 3.72581 0.885986 3.317C0.885721 2.49138 1.21344 1.69948 1.79706 1.11549C2.38067 0.531499 3.17237 0.203268 3.99799 0.203003C4.82361 0.202738 5.61551 0.530459 6.1995 1.11407C6.78349 1.69769 7.11172 2.48938 7.11199 3.315Z"
      fill={color}
    />
    <path
      d="M4 17.111C5.71871 17.111 7.112 15.7177 7.112 13.999C7.112 12.2803 5.71871 10.887 4 10.887C2.28129 10.887 0.888 12.2803 0.888 13.999C0.888 15.7177 2.28129 17.111 4 17.111Z"
      fill={color}
    />
    <path
      d="M4 27.797C5.71871 27.797 7.112 26.4037 7.112 24.685C7.112 22.9663 5.71871 21.573 4 21.573C2.28129 21.573 0.888 22.9663 0.888 24.685C0.888 26.4037 2.28129 27.797 4 27.797Z"
      fill={color}
    />
  </svg>
);

VerticalPointsIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number,
  /**
   * Margin at the left of the icon
   */
  marginLeft: PropTypes.number,
  /**
   * CSS transition
   */
  transition: PropTypes.string,
  /**
   * CSS transform
   */
  transform: PropTypes.string
};

VerticalPointsIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0,
  marginLeft: 0,
  transition: "0s",
  transform: ""
};

export default VerticalPointsIcon;
